import React from 'react';
import {KeyboardDatePicker as DatePicker} from '@material-ui/pickers';
import classNames from 'classnames';
import styles from '../styles/styles.js';
import PropTypes from 'prop-types';
import FormHelperText from './FormHelperText.jsx';
import formatError from '../utils/formatError';

const wrapError = (err) => err && typeof err === 'string' ? (
    <FormHelperText role="alert" aria-label={formatError(err)}>
      {formatError(err)}
    </FormHelperText>
) : err;

const {makeStyles} = styles;

const KeyboardDatePicker = (props) => {
  const classes = useStyles();
  const {
    error,
    disabled,
    format,
    onChange,
    name,
    label,
    id,
    value,
    invalidDateMessage,
    minDateMessage,
    maxDateMessage,
    ...rest
  } = props;
  return (
    <DatePicker
      {...rest}
      KeyboardButtonProps={{'aria-label': 'change date'}}
      className={ classNames(classes.date, !!error && classes.errorInput) }
      inputVariant={ 'outlined' }
      disabled={disabled}
      id={ id || 'date-picker' }
      format={ format || 'yyyy/MM/DD' }
      onChange={ onChange }
      name={ name }
      label={ label }
      value={ value }
      invalidDateMessage={wrapError(invalidDateMessage)}
      minDateMessage={wrapError(minDateMessage)}
      maxDateMessage={wrapError(maxDateMessage)}
      clearable
    />
  );
};

KeyboardDatePicker.propTypes = {
  'label': PropTypes.string.isRequired,
  'value': PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  'disabled': PropTypes.bool,
  'name': PropTypes.string.isRequired,
  'format': PropTypes.string,
  'valueFormat': PropTypes.string,
  'data-testid': PropTypes.string,
  'error': PropTypes.bool,
  'onChange': PropTypes.func,
  'id': PropTypes.string,
  'invalidDateMessage': PropTypes.node,
  'minDateMessage': PropTypes.node,
  'maxDateMessage': PropTypes.node,
};

const useStyles = makeStyles(() => ({
  date: {
    width: '100%',
  },
  errorInput: {
    '& label': {
      color: '#CF0000',
    },
    '& div.MuiInputBase-root fieldset': {
      borderColor: '#CF0000',
    },
    '& p.MuiFormHelperText-root': {
      color: '#CF0000',
    },
  },
}));

export default KeyboardDatePicker;
